export const API_RADAR = {
  DEFAULT_API_URL: '/display/',
  DEFAULT_TOKEN: 'L7RIiyxO3dZKfIt4FLlTdAUXTB834nrC',
  SETTINGS_API_URL: 'settings.php',
  FILTERS_API_URL: 'filters.php',
  LOCATIONS_API_URL: 'locations.php',
  SEARCH_API_URL: 'search.php',
  ZONES_API_URL: 'zones.php',
  BRANDS_API_URL: 'summary_brand.php',
  SOURCES_API_URL: 'summary_source.php',
  DISTRIBUTIONS_API_URL: 'summary_distribution.php',
  SUB_DIVISIONS_API_URL: 'subdivisions.php',
  KPIS_API_URL: 'kpis.php',
}

export const API_GEOJSON = {
  DEFAULT_API_URL: '/countries/',
}
